export default __webpack_public_path__ + "static/media/fb.d8abe141.svg";